import { Clock, User, ChevronRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import type { BlogPost } from '../types';

export function BlogCard({ post }: { post: BlogPost }) {
  return (
    // 🔹 Card Container
    <Link
      to={`/blog/${post.slug}`}
      className="bg-gray-900 border border-gray-800 rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow hover:scale-[1.01] flex flex-col"
    >
      {/* 🔹 Blog Thumbnail */}
      <div className="relative h-56 sm:h-60">
        <img
          src={post.image}
          alt={post.title}
          className="w-full h-full object-cover"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
        <div className="absolute bottom-0 left-0 p-4">
          <span className="px-3 py-1 bg-yellow-500 text-black rounded-full text-sm font-medium">
            {post.category}
          </span>
        </div>
      </div>

      {/* 🔹 Content Block */}
      <div className="p-6 flex flex-col flex-grow">
        {/* 🔹 Meta: author & date */}
        <div className="flex items-center justify-between mb-4 text-sm text-yellow-300">
          <div className="flex items-center gap-2">
            <User className="w-4 h-4" />
            {post.author}
          </div>
          <span>{post.date}</span>
        </div>

        {/* 🔹 Title */}
        <h3 className="font-bold text-xl mb-2 line-clamp-2 text-yellow-400 group-hover:text-yellow-300 transition-colors">
          {post.title}
        </h3>

        {/* 🔹 Excerpt */}
        <p className="text-yellow-100 text-sm mb-4 line-clamp-3">{post.excerpt}</p>

        {/* 🔹 Read Time + CTA */}
        <div className="flex items-center justify-between mt-auto pt-2">
          <div className="flex items-center gap-2 text-sm text-yellow-300">
            <Clock className="w-4 h-4" />
            {post.readTime}
          </div>
          <span className="text-yellow-400 hover:text-yellow-300 font-medium text-sm inline-flex items-center">
            Read More <ChevronRight className="ml-1 w-4 h-4" />
          </span>
        </div>
      </div>
    </Link>
  );
}
